
import debounce from 'lodash/debounce'
import 'components/treeview.tag'
riot.tag2('catalog-tree', '  <div class="row" if="{opts.add || opts.reload || opts.remove || opts.search}">\n    <div class="col-md-8 col-sm-6 col-xs-12">\n      <div class="form-inline m-b-2">\n        <button class="btn {allMode ? &quot;btn-primary&quot; : &quot;btn-default&quot;}" if="{opts.allselect &amp;&amp; (totalCount &gt; 0)}" type="button" onclick="{selectedAll}" title="{allMode ? &quot;Снять выделение&quot; : &quot;Выделить всё&quot;}"><i class="fa {allMode ? &quot;fa-toggle-on&quot; : &quot;fa-toggle-off&quot;}"></i></button>\n        <button class="btn btn-primary" if="{opts.add}" onclick="{opts.add}" type="button"><i class="fa fa-plus"></i> Добавить</button>\n        <button class="btn btn-success" if="{opts.reload}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n        <button class="btn btn-primary" if="{opts.deselall}" onclick="{deselAll}" title="Показать все" type="button"><i class="fa fa-share"></i></button>\n        <button class="btn btn-danger" if="{opts.remove &amp;&amp; selectedCount}" onclick="{remove}" title="Удалить" type="button"><i class="fa fa-trash">{(selectedCount > 1) ? ⁗&nbsp;⁗ : ⁗⁗}</i><span class="badge" if="{selectedCount &gt; 1}">{selectedCount}</span></button>\n        <button class="btn btn-primary" if="{opts.reorder &amp;&amp; selectedCount}" onclick="{reorderNext}" title="Вниз" type="button"><i class="fa fa-arrow-down"></i></button>\n        <button class="btn btn-primary" if="{opts.reorder &amp;&amp; selectedCount}" onclick="{reorderPrev}" title="Вверх" type="button"><i class="fa fa-arrow-up"></i></button>\n        <yield from="head"></yield>\n      </div>\n    </div>\n    <div class="col-md-4 col-sm-6 col-xs-12">\n      <form class="form-inline text-right m-b-2">\n        <div class="form-group">\n          <div class="input-group" if="{opts.search}">\n            <input class="form-control" name="search" type="text" placeholder="Поиск" onkeyup="{find}"><span class="input-group-btn">\n              <button class="btn btn-default" onclick="{find}" type="submit"><i class="fa fa-search"></i></button></span>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-md-12">\n      <treeview nodes="{nodes}" handlers="{opts.handlers}" label-field="{opts.labelField}" children-field="{opts.childrenField}" loader="{loader}" descendants="{opts.descendants}" dblclick="{opts.dblclick}">\n        <yield to="before">\n          <yield from="before"></yield>\n        </yield>\n        <yield to="after">\n          <yield from="after"></yield>\n        </yield>\n      </treeview>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var _this2 = this;

var self = this;

self.mixin('permissions');
self.allMode = false;
self.nodes = [];
self.selectedCount = 0;
self.handlers = opts.handlers;

// перезагрузить
self.reload = function () {
    self.trigger('reload');
    self.allMode = false;
    self.loader = true;
    self.update();
    self.deselAll();

    /** перезугрузка другого списка (удаляем группу - перезагружаем и список групп в товарах) */
    if (opts.observableTrigger) observable.trigger(opts.observableTrigger);

    var params = {};
    params.isTree = true;

    if (opts.search && self.search) {
        params.searchText = self.search.value;
    }

    /** API.request
     *
     * @param str opts.object  exp:Category
     * @param bool isTree  true-древовидный список
     * @param str searchText  искомый текст
     * @return array response.items  массив групп
     */
    API.request({
        object: opts.object,
        method: 'Fetch',
        data: params,
        success: function success(response) {
            self.nodes = response.items;
            if (opts.exception) {
                self.tags.treeview.exceptionFilter(self.nodes, opts.exception);
            }
            self.totalCount = response.items.length;
        },
        complete: function complete() {
            self.loader = false;
            self.update();
        }
    });
};

// выделить все
self.selectedAll = function () {
    //self.allMode = self.tags.treeview.selectAllRows(self.allMode);
    if (self.allMode == false) {
        self.allMode = true;
        self.selectedCount = self.totalCount;
        self.tags.treeview.selectAllRows();
    } else {
        self.deselAll();
    }

    observable.trigger('catalog-recount', true);
};

// сброс выбора в списке
self.deselAll = function (e) {
    self.allMode = false;
    self.selectedCount = 0;
    self.tags.treeview.deselectAll();
    if (self.opts.object == 'Category') observable.trigger('products-reload', []); // перезагрузка листа товаров
    if (self.opts.object == 'WarehouseBrand') observable.trigger('warehouse-reload', []); // перезагрузка листа товаров
};

self.remove = function (e) {
    /** удалить
     * 1 обнулить выделение элементов
     */

    var _this = _this2;

    var items = self.tags.treeview.getSelectedNodes();
    var itemsToRemove = items.map(function (i) {
        return i.id;
    });

    if (opts.remove) opts.remove.bind(_this2, e, itemsToRemove, self)();

    //self.deselAll(); //1
};

self.afterRemove = function () {
    self.tags.treeview.removeNodes();
    self.update();
};

self.find = debounce(function (e) {
    self.reload();
}, 400);

self.on('mount', function () {
    self.reload();
});

self.on('update', function () {
    self.handlers = opts.handlers;
    if (self.selectedCount != self.totalCount) {
        self.allMode = false;
    }
});

self.one('updated', function () {
    self.tags.treeview.on('nodeselect', function (item, count) {
        self.selectedCount = count;
        if (self.selectedCount === self.totalCount) {
            self.allMode = true;
        }
        self.update();
    });
});

self.reorderNext = function () {
    console.log("next");
};

self.reorderPrev = function () {
    console.log("prev");
};
});


// WEBPACK FOOTER //
// ./components/catalog-tree.tag